<template lang="pug">
  .document
    app-card.document__card(v-for="(d, index) in preparedDocuments" :key="index" @click.native="selectDocument(d)")
      app-card-header
        v-row.flex-nowrap(no-gutters align="baseline")
          .col-auto {{ d.date }} 
          .col-auto.ml-4 {{ d.time }}
          .col.ml-4.text-right(v-line-clamp="1") 
            | {{ d.deliveryStatus.title }} 
            | ({{ d.sendChannel.title }}
            span(v-if="d.trackings.length > 0")
               | , {{ trackingDateFormat(d.trackings[0]) }} - 
               router-link(:to="{ path: '//www.pochta.ru/tracking#' + d.barCode }" target="_blank") {{ d.trackings[0].typeName.title }}
            | )  
          .ellipse.ml-4(:data-color="d.color")

      
      app-card-body.document__card-body(v-if="d.sendable!=null && d.sendable.type=='FileRequest'")
        app-card-title.document__card-title {{ d.name }}
        app-card-caption(v-if="d.sendable.organization") Организация:  <b>{{ d.sendable.organization.name }} </b>
        app-card-caption {{memberTitleText}}: <b>{{ d.recipientName }}</b> {{ d.address }}

      app-card-body.document__card-body(v-else)
        app-card-title.document__card-title {{ d.name }}
        app-card-caption Получатель: <b>{{ d.recipientName }}</b> {{ d.address }}


    signDoc(v-model="dialog.sign" :doc.sync="document" @sended="sended" @sendfail="showErrorSnack($event)" @ok="showSuccessSnack($event)")

    app-dialog(v-model="dialogVisible" :header="documentName" :items="items" width="500")
    app-dialog(v-model="dialog.channels" :header="documentName" :items="preparedChannels" @select="changeChannel")

    app-dialog-confirm(v-model="dialog.docDelete" @confirm="remove(document)")
      app-card-title.mt-5 Вы уверены, что хотите удалить документ "<b>{{ document ? document.name : '' }}</b>"?

    v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
      v-btn(light text @click="errorSnack = false") Закрыть
    v-snackbar(v-model="successSnack" color="success" :timeout="6000" vertical top) {{successSnackText}}
      v-btn(light text @click="successSnack = false") Закрыть

</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { docService } from '@/_services'
import { AppDialogConfirm } from '@/components'
import signDoc from '../../signature/components/SignDoc'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const colors = ['red', 'yellow', 'green']

export default {
  name: 'case-documents',
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    signDoc
  },
  props: {
    docList: null,
    memberTitle: String
  },

  computed: {
    ...mapState('courtCase', ['courtCase']),
    ...mapGetters('courtCase', ['channels', 'members', 'documents', 'caseId', 'caseEssence', 'caseLawArticle',]),

    memberTitleText () {
      return this.memberTitle ? this.memberTitle : 'Сторона по делу'
    },

    documentName () {
      return this.document ? `${ this.document.name } (${ this.document.sendChannel.title })` : ''
    },

    items () {
      let it = []
      if  (this.document != null) {
        let status = this.document.deliveryStatus.name

        if (status == 'SIGNREQUIRED') {
            it.push({ icon: 'gesture', title: 'Подписать и отправить', action: () => this.showSignDocDialog() })
            if (!(window.settings.limitMenu && window.settings.limitMenu.available==true && window.settings.limitMenu.key== 'gsu')) 
              it.push({ icon: 'send', title: 'Отправить без ЭЦП', action: () => this.send(this.document) })
        }

        if (status == 'NOTSENDED' || status == 'RETURNED')
            it.push({ icon: 'send', title: 'Отправить', action: () => this.send(this.document) })

        if (this.document.sendable.type != 'FileRequest' && (status == 'SIGNREQUIRED' || status == 'NOTSENDED' || status == 'RETURNED'))
            it.push({ icon: 'transform', title: 'Изменить способ отправки', action: () => this.showChangeChannelDialog() })

        if (status == 'SIGNREQUIRED' || status == 'NOTSENDED' || status == 'RETURNED') {
            if(this.document.sendable!=null && this.document.sendable.result.indexOf('.docx')>0)
                it.push({ icon: 'edit', title: 'Редактировать', action: () => this.open(this.document) })
            it.push({ icon: 'delete', title: 'Удалить', action: () => this.showDeleteDialog() })
        } else {
            if (status == 'NOTDELIVERED') 
              it.push({ icon: 'send', title: 'Повторить отправку', action: () => this.resend() })
            if (status == 'RECEIVED') {
              it.push({ icon: 'edit', title: 'Просмотреть', action: () => this.viewdoc() })
            } else {
              it.push({ icon: 'edit', title: 'Просмотреть', action: () => this.view(this.document) })
            }
            if (this.document.sendChannel.name == "EMAIL")
                it.push({ icon: 'print', title: 'Распечатать отчет', action: () => this.createPDF(this.document) })
        }
      }
      return it
    },

    preparedDocuments () {
      if( this.docList!=null ) return this.docList
      return this.documents.map(d => {
        d.date = this.date(d)
        d.time = this.time(d)
        d.color = this.statusColor(d)

        let recipient = this.recipient(d)
        d.recipientName = this.recipientName(recipient)

        if (d.sendable!=null && d.sendable.type=="FileRequest") d.name="Запрос: "+d.name

        if (d.factAddress) {
          d.address = d.factAddress
        }
        else if (recipient.persona.personaData) {
          let type = d.sendChannel.name === "POST" || d.sendChannel.name === "PERSONALLY" ? "ADDRESS" : "EMAIL"
          let addressItems = recipient.persona.personaData.filter(item => item.dataType.name === type).sort((a, b) => b.id - a.id)
          let item = addressItems.find(item => item.tag && item.tag.name == 'MAIN') || addressItems[0]
          d.address = item ? item.data : ''
        }
        d.recipientEmail = recipient.persona.email
        return d
      })
    },


    preparedChannels () {
      if(this.document!=null && this.document.sendable!=null && this.document.sendable.type=="FileRequest") 
        return this.channels.filter(item => item.filter < 2)
      else 
        return this.channels.filter(item => item.filter == 0)
    },
    
  },

  methods: {
    ...mapActions('courtCase', ['updateChannel', 'LOAD_CASE']),
    ...mapMutations('courtCase', ['setCurrentDocId']),

    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },

    showSuccessSnack(text) {
      this.successSnackText = text
      this.successSnack = true
    },
   
    showChangeChannelDialog () {
      this.dialog.channels = true
    },

    showDeleteDialog() {
      this.dialog.docDelete = true
    },

    showSignDocDialog() {
      this.dialog.sign = true
    },

    date (d) {
      return moment(d.createDate).format("DD.MM.YYYY")
    },

    time (d) {
      return moment(d.createDate).format("HH:mm")
    },

    trackingDateFormat(track) {
      return moment(track.operDate).format("DD.MM.YYYY HH:mm")
    },

    statusColor (d) {
      return colors[d.deliveryStatus.color]
    },

    recipient (d) {
      let member = this.members.find(m => m.id == d.sendable.memberId)
      return member ? member : {persona:{address: "Адрес организации", name:"Запрос на организацию", personaType: "UL"}}
    },

    recipientName (member) {
      let { persona } = member
      return (persona.personaType.name == 'UL' && persona.orgName.length > 0) ? persona.orgName : persona.name
    },

    selectDocument (d) {
      if (d.docOrigin && d.docOrigin.name == 'POSTCAB') return
      this.document = d
      // if (d.deliveryStatus.name == 'RECEIVED') this.viewdoc() 
      // else 
        this.dialogVisible = true

    },

    sended () {
      this.LOAD_CASE(this.caseId)
    },

    send () {
      docService.send(this.document.id)
      .then(() => this.LOAD_CASE(this.caseId))
    },

    resend () {
      docService.resend(this.document.id)
      .then(() => this.LOAD_CASE(this.caseId))
    },

    open () {
      let { sendable } = this.document
      if (sendable && sendable.result) {
        let link="ms-word:ofe|u|"+document.location.origin+sendable.result
        window.open(link, '_self')

      }
    },

    view () {
      let { sendable } = this.document
      if (sendable && sendable.result) {
        let link="ms-word:ofv|u|"+document.location.origin+sendable.result
        window.open(link, '_self')
      }
    },

    viewdoc () {
      this.setCurrentDocId(this.document.id)
      this.$router.push(`/case/${this.document.caseId}/doc/${this.document.id}`)
    },

    remove () {
      docService.deleteId(this.document.id)
      .then(() => {
        this.LOAD_CASE(this.caseId)
        // for (let index = 0; index < this.currentSession.sessionDocs.length; index++) {
        //   const element = this.currentSession.sessionDocs[index];
        //   if (element.id == d.id) {
        //     this.currentSession.sessionDocs.splice(index, 1)
        //     break
        //   }
        // }
      })
      .catch(e => {
        console.log(e)
        if (e.response && e.response.status == 403) {
          this.$root.$emit('mes', 'Не удалось удалить документ - операция не доступна')
        }
      })
    },

    changeChannel (channel) {
      if((channel.name=="EMAIL" || channel.name=="EMAILCRYPT") && (this.document.recipientEmail==null || this.document.recipientEmail=="")) 
        this.showErrorSnack("У получателя не заполнен E-mail")
      else 
        this.updateChannel({ document: this.document, channel })
    },

    createPDF (document) {
      let point = document.docRoutePoints.find(item => item.deliveryStatus.name === document.deliveryStatus.name)
      
      let theme = this.caseEssence ? this.caseEssence : this.caseLawArticle ? this.caseLawArticle : this.courtCase.caseCategory ? this.courtCase.caseCategory.title : "Не определена"

      let contentBody = [
        ["От кого:", this.courtCase.court.name + " г." + this.courtCase.court.city + " <" + this.courtCase.court.email + ">"],
        ["Кому:", document.recipientName + " <" + document.recipientEmail + ">"],
        ["Дело:", this.courtCase.number],
        ["Тема:", theme],
        ["Отправлено:", document.date + " " + document.time],
        ["Статус(Дата):", document.deliveryStatus.title + " (" + moment(point.statusDate).format("DD.MM.YYYY HH:mm") + ")"],
        ["Вложение:", document.name],
      ]

      var contentPDF = {
        content: [
          {text: this.courtCase.court.name + " г." + this.courtCase.court.city, style: 'header'},
          { style: 'tableExample', table: { widths: [100,'*'], body: contentBody }},
        ],
        styles: {
          header: { fontSize: 14,  bold: true, margin: [0, 0, 0, 10] },
          tableExample: { margin: [0, 5, 0, 15], fontSize: 9 }
        }
      }

      pdfMake.createPdf(contentPDF).open()
    },

  },

  data () {
    return {
      errorSnackText: "Ошибка при подписании",
      successSnackText: "Подпись верна",
      errorSnack: false,
      successSnack: false,
      channelChanging: false,
      dialogVisible: false,
      document: null,
      dialog: {
        sign: false,
        channels: false,
        docDelete: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.document__card-body {
  padding: 16px;
}
.document__card-title {
  margin-bottom: 12px !important;
}


.sud-full-width {
  width: 100%;
}

.sud-font-slab-18 {
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 16px;
}
.sud-font-cond-16 {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
}

.sud-corners-top {
  border-radius: 5px 5px 0px 0px;
}

.sud-dialog-header {
  background: #959595;
  padding: 27px 25px 27px 46px;
  color: #FFFFFF;
}
.sud-dialog-content {
  background-color: #FFFFFF;
  padding: 0px 24px 17px 22px;

  &__list-item {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 18px;

    &:hover {
      background-color: #00BCD4;
      color: #080808;
    }
  }
}

.sud-card {
  margin-bottom: 8px;
  border-radius: 5px 5px 0px 0px;
}

.sud-card-header {
  background: #F0F0F0;
  height: 42px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;

  color: #757575;
}

.sud-card-title {
  margin-bottom: 8px;

  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;

  color: #314369;
}

.sud-card-recipient {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;

  color: #757575;
}

.ellipse {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 6px;

  &[data-color="red"] {
    background: #ED0E51;
  }
  &[data-color="yellow"] {
    background: #F2BE38;
  }
  &[data-color="green"] {
    background: #2BC113;
  }
}
</style>